"use client";

import React, { forwardRef } from "react";
import { FieldError } from "react-hook-form";

const PERSIAN_LETTERS_REGEX = /[^\u0600-\u06FF\s\u200c]/g;

interface PersianLetterInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
  errors?: FieldError;
  requiredMark?: boolean;
}

const PersianLetterInput = forwardRef<
  HTMLInputElement,
  PersianLetterInputProps
>(({ label, errors, requiredMark, onChange, className, ...rest }, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filtered = e.target.value.replace(PERSIAN_LETTERS_REGEX, "");
    e.target.value = filtered;
    onChange?.(e);
  };

  return (
    <div className="flex flex-col gap-1 w-full">
      {label && (
        <label className="text-sm font-medium text-white">
          {label}
          {requiredMark && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <input
        {...rest}
        ref={ref}
        type="text"
        lang="fa"
        inputMode="text"
        autoComplete="off"
        onChange={handleChange}
        className={`
          w-full px-3 py-2.5 rounded-lg bg-[#F2F4F7] text-[#1E1D39]
          placeholder:text-neutral-400 border border-neutral-300
          focus:outline-none ${errors ? "border-red-500" : "focus:ring-1 focus:ring-[#444CE7]"}
          transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed
          ${className || ""}
        `}
      />

      {errors && <p className="text-red-600 text-sm mt-1">{errors.message}</p>}
    </div>
  );
});

PersianLetterInput.displayName = "PersianLetterInput";

export default PersianLetterInput;
